import { render, staticRenderFns } from "./ScreenTimestamp.vue?vue&type=template&id=0dae615d&scoped=true"
import script from "./ScreenTimestamp.vue?vue&type=script&lang=js"
export * from "./ScreenTimestamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae615d",
  null
  
)

export default component.exports